import { render, staticRenderFns } from "./K8sForm.vue?vue&type=template&id=9d803acc"
import script from "./K8sForm.vue?vue&type=script&lang=js"
export * from "./K8sForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports